import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { siteConfig } from '../data/config';

/**
 * scroll   — moves to the purchase panel (used before the offer)
 * checkout — opens the real checkout; inactive until a checkout URL is confirmed
 * auto     — checkout when available, otherwise the purchase panel (used after the offer)
 */
type Mode = 'scroll' | 'checkout' | 'auto';
interface PurchaseButtonProps {
  mode?: Mode;
  label?: string;
  fullWidth?: boolean;
  compact?: boolean;
  className?: string;
}
export function PurchaseButton({
  mode = 'scroll',
  label = 'Get the Complete Collection',
  fullWidth = false,
  compact = false,
  className = ''
}: PurchaseButtonProps) {
  const size = compact ? 'min-h-[46px] px-5 text-[15px]' : 'min-h-[56px] px-8 text-[17px]';
  const base = `inline-flex items-center justify-center gap-2 rounded-[8px] bg-amber font-bold text-charcoal shadow-[0_6px_18px_rgba(0,0,0,0.18)] transition-[background-color,transform] duration-150 ease-out hover:bg-amberHover focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-[3px] focus-visible:outline-amber ${size} ${fullWidth ? 'w-full' : ''} ${className}`;
  const url = siteConfig.checkoutUrl;
  if (mode === 'checkout' && !url) {
    return <button type="button" disabled title="Checkout is not available yet" className={`${base} cursor-not-allowed opacity-60`} data-id="element-27" data-mp="11os9v88rcmwu">
        {label}
      </button>;
  }
  const href = mode === 'scroll' ? '#offer' : url || '#offer';
  return <a href={href} className={`${base} active:scale-[0.98]`} data-id="element-28" data-mp="16mtqlmipoa55">
      {label}
      <ArrowRightIcon className="h-[18px] w-[18px] shrink-0" strokeWidth={2.5} aria-hidden="true" data-id="element-29" data-mp="1kll0sxugdbo0" />
    </a>;
}